import { render, staticRenderFns } from "./orderPop.vue?vue&type=template&id=2becfa4f&scoped=true"
import script from "./orderPop.vue?vue&type=script&lang=js"
export * from "./orderPop.vue?vue&type=script&lang=js"
import style0 from "./orderPop.vue?vue&type=style&index=0&id=2becfa4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2becfa4f",
  null
  
)

export default component.exports